export const routes = (prefix = `radiology`) => [
    {
        path: `/${prefix}/past-queue`,
        name: `${prefix}.past-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.past-queue.index`,
                PageDescription: "Radiology: Past Patient Queue",
            },
        },
    },
];
